// @flow

import React from 'react';
import PropTypes from "prop-types";
import FileReaderInput from 'react-file-reader-input';

import Tbutton from './Tbutton';

const propTypes = {
    children: PropTypes.node.isRequired,
    as: PropTypes.oneOf(['binary', 'buffer', 'text', 'url']),
    width: PropTypes.string,
    className: PropTypes.string,
    accept: PropTypes.string,
	button: PropTypes.bool,
    /**
     * onClick(onClickParam, fileData, fileName);
     */
    onClick: PropTypes.func,
    onClickParam: PropTypes.any
};

const defaultProps = {
	as: 'binary',
	button: false
};


class Tfile extends React.Component {
	constructor(props) {
		super(props);
		this.onChange = this.onChange.bind(this);
		this.onClick = this.onClick.bind(this);
		this.state = {fileName: null};
	}
	
	onChange(e, results) {
		if (this.props.onClick && results.length > 0) {
			const [pe, file] = results[0];
			this.props.onClick(this.props.onClickParam, pe.target.result, file.name);
			this.setState({fileName: file.name});
		}
	}
	
	onClick(e) {
		e.target.value = null;
	}

	renderButton() {
		if (!this.props.button)
			return (<Tbutton className={this.props.className} width={this.props.width}>{this.props.children}</Tbutton>);
		return (
			<div className={"input-group " + this.props.className}>
				<div className="input-group-addon" style={{cursor: "pointer"}}>
					<span className="input-group-text">{this.props.children}</span>
				</div>
				<input type="text" className="form-control" value={this.state.fileName || ""} readOnly={true} style={{cursor: "pointer"}}/>
			</div>
		);
	}
	
	render() {
		return (
			<FileReaderInput as={this.props.as}
				accept={this.props.accept}
            	onChange={this.onChange}
				onClick={this.onClick}>
				{this.renderButton()}
			</FileReaderInput>);
	}
}

Tfile.propTypes = propTypes;
Tfile.defaultProps = defaultProps;

export default Tfile;
